<ng-container *ngIf="data$ | async as data">
  <div class="modal-backdrop-custom" (click)="close()"></div>
  <div class="modal-custom" role="dialog" aria-modal="true">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content modal-content-qty" *ngIf="data.errorType === 'orderTotalLimit'">
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="qty-icon">
          <img
            class="icon img-fluid"
            alt="Warning"
            src="assets/images/icons/alert-icon-warning.png"
          />
        </div>
        <h4 class="qty-title" i18n>Maximum Order Total Limit Reached</h4>
        <p class="qty-description" i18n>
          Your order total exceeds the maximum allowed limit of ${{
            +data.limit | number: '1.2-2'
          }}. Please remove some items from your cart to continue.
        </p>
        <div class="qty-btn-wrapper">
          <button type="button" class="qty-btn-ok" (click)="close()" i18n>OK</button>
        </div>
      </div>
      <div class="modal-content modal-content-qty" *ngIf="data.errorType === 'quantityLimit'">
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="qty-icon">
          <img
            class="icon img-fluid"
            alt="Warning"
            src="assets/images/icons/alert-icon-warning.png"
          />
        </div>
        <h4 class="qty-title" i18n>Maximum Quantity Reached</h4>
        <p class="qty-description" i18n>
          You already have the maximum allowed quantity of this item in your cart.
        </p>
        <p class="qty-limit-text" i18n>This product is limited to {{ data.limit }} per order.</p>
        <div class="qty-btn-wrapper">
          <button type="button" class="qty-btn-ok" (click)="close()" i18n>OK</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
